import { createUseStyles } from 'react-jss';
const useActionButtonStyles = createUseStyles(() => ({
    common: {
        cursor: 'pointer',
        padding: '4px 8px',
        border: '1px solid #E1E4EA',
        borderRadius: '100px',
        background: 'transparent',
        height: '28px',
        color: '#525866',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px',
        transition: 'all 0.3s ease-out',
        width: ({ fullWidth }) => (fullWidth ? '100%' : 'auto'),
        '&:active': {
            backgroundColor: '#E1E4E9',
            borderColor: '#E1E4E9'
        }
    }
}));
export default useActionButtonStyles;
